import React from "react";

export default function Logo({ className = "h-16" }) {
  return (
    <img
      src="/logo-full.png"
      alt="Soft Spine Press — Independent Publisher, est. 2026, part of AntelliHQ"
      className={`${className} w-auto select-none`}
      draggable={false}
      data-testid="brand-logo"
    />
  );
}
